import { Injectable, Injector } from '@angular/core';
import { UserStateStatus } from '@lsq-frontend/remote-services/enterprise/common';
import {
    DatePickerConfiguration,
    IDateRange,
    LifecycleAware,
    ReportRequestUserSettings
} from '@lsq-frontend/common-ui';
import { Serializer } from '@lsq-frontend/common-ui';
import {
    ApiDefaults,
    ApiService,
    LsqApiServiceListSource
} from '@lsq-frontend/angular-shared/api-service';
import { UserStateService } from '@lsq-frontend/fasttrack-shared/features/user-state-service';

@LifecycleAware()
@Injectable()
export abstract class BaseReportComponent {
    public abstract apiService: ApiService<any, any>;
    public abstract dataSource: LsqApiServiceListSource<any, any>;
    public abstract analyticsName: string;
    public abstract userStateType: string;
    public abstract filterDate: Date | IDateRange;

    // Set to null if saving the date filter is not required.
    public abstract savedDateFilterName: string;

    public datePickerConfiguration: DatePickerConfiguration;

    // Services
    private _userStateService: UserStateService;
    private _serializer: Serializer;

    constructor(public injector: Injector) {
        this._userStateService = this.injector.get(UserStateService);
        this._serializer = this.injector.get(Serializer);
    }

    public abstract dispatchInitialRequest(datePickerRange?: number): Promise<void>;
    public abstract getInitialDateFilter(): IDateRange | Date;
    public abstract handleDatePickerChange(dateFilter: IDateRange | Date): void;
    public abstract configureDatePicker(initialDateFilter: IDateRange | Date): void;

    public handleTakeChange(newTake: number): void {
        // tslint:disable-next-line: no-floating-promises
        this._userStateService.createOrUpdateUserState(
            this.userStateType,
            UserStateStatus.Done, // TODO: remove when BE makes optional.
            { take: newTake }
        );
    }

    public async getTakeFromUserState(): Promise<number> {
        const userState = await this._userStateService.getUserState(this.userStateType);

        return userState?.jsonData
            ? (this._serializer.deserialize(userState.jsonData) as ReportRequestUserSettings).take
            : ApiDefaults.TakeDefault;
    }
}
